import React, { Component } from 'react';
import { Form } from 'antd';

const FormItem = Form.Item;

export default class EditableCell extends Component {
  render() {
    const {
      dataIndex,
      editing,
      EditableContext,
      getInput,
      index,
      record,
      required,
      title,
      ...restProps
    } = this.props;

    // If the dataindex is a nester prop we need to get it
    let initialValue = record;
    dataIndex && dataIndex.split('.').forEach(prop => {
      initialValue = initialValue[prop];
    });

    return (
      <EditableContext.Consumer>
        {(form) => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              { editing ? (
                <FormItem>
                  { getFieldDecorator(dataIndex, {
                    rules: [{
                      message: `Please enter a ${title}`,
                      required
                    }],
                    initialValue: initialValue
                  })(getInput())}
                </FormItem>
              ) : restProps.children }
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}
